import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { TimeBasedSettingForCallersGroupDto } from '../../../dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { TimeBasedSettingForCallersGroupRequest } from './timebasedsettingforcallersgrouprequest';
import { WeekDaysToNumberConverter } from '../../../dto/timebasedsetting/weekdaystonumberconverter';
import { Strings } from '../../../../utils/resources/strings';
import * as moment from 'moment';
import { DateTransform } from '../../../../ui/toolkit/datetransform/datetransform';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class TimeBasedSettingForCallersGroupAPI extends SixdeeCRBTAPI<TimeBasedSettingForCallersGroupRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod()
    {
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/add-tone-to-group-with-time-setting
        return "add-tone-to-group-with-time-setting";
    }

    getRequestData()
    {
        let timeBasedSettingForCallersGroupRequestDto : TimeBasedSettingForCallersGroupDto;
        timeBasedSettingForCallersGroupRequestDto = this.getRequest().getTimeBasedSettingForCallersGroupRequest();

        let commonRequestParameters : string = "clientTxnId=21072020"+"&"+
        "aPartyMsisdn=" + timeBasedSettingForCallersGroupRequestDto.getAPartyMsisdn()+"&"+
        "toneId="+ timeBasedSettingForCallersGroupRequestDto.getToneId()+"&"+
        "language="+ (timeBasedSettingForCallersGroupRequestDto.getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
        "priority="+ timeBasedSettingForCallersGroupRequestDto.getPriority()+"&"+
        "channelId="+ timeBasedSettingForCallersGroupRequestDto.getChannelId()+"&"+
        "groupId="+ timeBasedSettingForCallersGroupRequestDto.getGroupId()+"&"+
        "groupName="+ timeBasedSettingForCallersGroupRequestDto.getGroupName()+"&"+
        "groupDesc="+ timeBasedSettingForCallersGroupRequestDto.getGroupDesc()+"&"+
        "serviceId=" + timeBasedSettingForCallersGroupRequestDto.getServiceId()+"&"+
        "activityId="+ timeBasedSettingForCallersGroupRequestDto.getActivityId()+"&"+
        "toneDetails=[\""+ timeBasedSettingForCallersGroupRequestDto.getToneId()+"\"]";

        let timeSettingSelected = timeBasedSettingForCallersGroupRequestDto.getTimeSettingSelected();
        
        if(timeSettingSelected === this.getContext().getResources().getString(Strings.full_day))
        {
            return commonRequestParameters+"&"+
            "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
            "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForCallersGroupRequestDto.getWeeklyDays())+"&"+
            "weeklyStartTime="+ this.getContext().getResources().getString(Strings.default_start_time)+"&"+
            "weeklyEndTime="+ this.getContext().getResources().getString(Strings.default_end_time);
        }
        else if(timeSettingSelected === this.getContext().getResources().getString(Strings.select_time))
        {
            return commonRequestParameters+"&"+
            "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
            "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForCallersGroupRequestDto.getWeeklyDays())+"&"+
            "weeklyStartTime="+ timeBasedSettingForCallersGroupRequestDto.getStartTimestamp() +"&"+
            "weeklyEndTime="+ timeBasedSettingForCallersGroupRequestDto.getEndTimestamp();
        }
        else
        {
            let repeatInterval = timeBasedSettingForCallersGroupRequestDto.getRepeatInterval();
            let startDate = timeBasedSettingForCallersGroupRequestDto.getStartTimestamp().split(" ");
            let endDate = timeBasedSettingForCallersGroupRequestDto.getEndTimestamp().split(" ");
                
            if(repeatInterval === this.getContext().getResources().getString(Strings.none))
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.CUSTOM_TIME) +"&"+
                   //"customizeStartDate="+ moment(startDate[0], "DD/MM/yyyy").format("yyyy-MM-DD") +"&"+
                   "customizeStartDate="+ DateTransform.formatDateForBackend(startDate[0]) +"&"+
                   //"customizeEndDate="+ moment(endDate[0], "DD/MM/yyyy").format("yyyy-MM-DD") +"&"+
                   "customizeEndDate="+ DateTransform.formatDateForBackend(endDate[0]) +"&"+
                   "customizeStartTime="+ startDate[1] +"&"+
                   "customizeEndTime="+ endDate[1];
            }
            else if(repeatInterval === this.getContext().getResources().getString(Strings.monthly))
            {
                let startDateformat = moment(startDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
                let endDateformat = moment(endDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
    
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.MONTHLY_TIME) +"&"+
                   /* "startDayMonthly="+ String(moment(startDateformat).date()) +"&"+
                   "endDayMonthly="+ String(moment(endDateformat).date()) +"&"+ */
                   "startDayMonthly="+ String(moment(startDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "endDayMonthly="+ String(moment(endDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "monthlyStartTime="+ startDate[1] +"&"+
                   "monthlyEndTime="+ endDate[1];

            }
            else if(repeatInterval === this.getContext().getResources().getString(Strings.yearly))
            {
                let startDateformat = moment(startDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");
                let endDateformat = moment(endDate[0], "DD/MM/yyyy").format("MM/DD/yyyy");

                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.YEARLY_TIME) +"&"+
                  /*  "yearlyStartMonth="+ String(moment(startDateformat).month() + 1) +"&"+
                   "yearlyEndMonth="+ String(moment(endDateformat).month() + 1) +"&"+
                   "yearlyStartDay="+ String(moment(startDateformat).date()) +"&"+
                   "yearlyEndDay="+ String(moment(endDateformat).date()) +"&"+ */
                   "yearlyStartMonth="+ String(moment(startDateformat, 'MM/DD/YYYY').format('MM')) +"&"+
                   "yearlyEndMonth="+ String(moment(endDateformat, 'MM/DD/YYYY').format('MM')) +"&"+
                   "yearlyStartDay="+ String(moment(startDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "yearlyEndDay="+ String(moment(endDateformat, 'MM/DD/YYYY').format('DD')) +"&"+
                   "yearlyStartTime="+ startDate[1] +"&"+
                   "yearlyEndTime="+ endDate[1];
            }
            else
            {
                return "";
            }
        }    

        /* // CALLERS GROUP - Full Day/Specific Time - Selected days of the week
        if(timeBasedSettingForCallersGroupRequestDto.getWeeklyStartTime() !== undefined &&
        timeBasedSettingForCallersGroupRequestDto.getWeeklyEndTime() !== undefined)
        {
            return commonRequestParameters+"&"+
                  "timeType="+ this.getContext().getResources().getString(Strings.WEEKLY_TIME) +"&"+
                   "weeklyDays="+ new WeekDaysToNumberConverter().convertWeekDaysToNumber(timeBasedSettingForCallersGroupRequestDto.getWeeklyDays())+"&"+
                   "weeklyStartTime="+ timeBasedSettingForCallersGroupRequestDto.getWeeklyStartTime()+"&"+
                   "weeklyEndTime="+ timeBasedSettingForCallersGroupRequestDto.getWeeklyEndTime();
        }
        else // CALLERS GROUP - Specific Date & Time
        {
            // CALLERS GROUP - Specific Date & Time - Monthly repeat
            if(timeBasedSettingForCallersGroupRequestDto.getStartDayMonthly() !== undefined &&
               timeBasedSettingForCallersGroupRequestDto.getEndDayMonthly() !== undefined)
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.MONTHLY_TIME) +"&"+
                   "startDayMonthly="+ timeBasedSettingForCallersGroupRequestDto.getStartDayMonthly()+"&"+
                   "endDayMonthly="+ timeBasedSettingForCallersGroupRequestDto.getEndDayMonthly()+"&"+
                   "monthlyStartTime="+ timeBasedSettingForCallersGroupRequestDto.getMonthlyStartTime()+"&"+
                   "monthlyEndTime="+ timeBasedSettingForCallersGroupRequestDto.getMonthlyEndTime();
            } // CALLERS GROUP - Specific Date & Time - Yearly repeat
            else if(timeBasedSettingForCallersGroupRequestDto.getYearlyStartMonth() !== undefined &&
                    timeBasedSettingForCallersGroupRequestDto.getYearlyEndMonth() !== undefined)
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.YEARLY_TIME) +"&"+
                   "yearlyStartMonth="+ timeBasedSettingForCallersGroupRequestDto.getYearlyStartMonth()+"&"+
                   "yearlyEndMonth="+ timeBasedSettingForCallersGroupRequestDto.getYearlyEndMonth()+"&"+
                   "yearlyStartDay="+ timeBasedSettingForCallersGroupRequestDto.getYearlyStartDay()+"&"+
                   "yearlyEndDay="+ timeBasedSettingForCallersGroupRequestDto.getYearlyEndDay()+"&"+
                   "yearlyStartTime="+ timeBasedSettingForCallersGroupRequestDto.getYearlyStartTime()+"&"+
                   "yearlyEndTime="+ timeBasedSettingForCallersGroupRequestDto.getYearlyEndTime();
            }
            else // CALLERS GROUP - Specific Date & Time - NO repeat
            {
                return commonRequestParameters+"&"+
                   "timeType="+ this.getContext().getResources().getString(Strings.CUSTOM_TIME) +"&"+
                   "customizeStartDate="+ timeBasedSettingForCallersGroupRequestDto.getCustomizeStartDate()+"&"+
                   "customizeEndDate="+ timeBasedSettingForCallersGroupRequestDto.getCustomizeEndDate()+"&"+
                   "customizeStartTime="+ timeBasedSettingForCallersGroupRequestDto.getCustomizeStartTime()+"&"+
                   "customizeEndTime="+ timeBasedSettingForCallersGroupRequestDto.getCustomizeEndTime();
            }
        } */
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupapi.tsx